export const authModalLayouts = {
  login: 'login',
  registration: 'registration',
  resetPass: 'reset',
  sendEmail: 'send-email'
};
